import { dateFriendly } from '../helpers/date';

/**
 * local function use to get error message
 * @param {Object} error response
 * @returns {String} messages
 */
const getErrorMessages = (error = {}) => {
	const fields = error?.response?.data?.fields || [];
	if (fields.length === 0) {
		if (error?.response?.data?.message) {
			return error?.response?.data?.message;
		}
		return error.message;
	}
	return fields.map((field) => {
		return field?.message.map((value) => {
			return value;
		});
	}).join(', ');
};

/**
 * Transform error from Rest API
 * @param {Object} error
 * @returns {Object}
 */
export const transformError = (error = {}) => {
	return {
		code: error?.response?.status,
		message: getErrorMessages(error),
	};
};

/**
 * transform error
 * @param {Object} error
 * @returns {Object}
 */
export const transformErrorData = (data = {}) => {
	return {
		id: data.id || null,
		type: data.type || null,
		message: data.message,
		remark: data.remark,
		channels: data.channel.name || '-',
		reportedAt: data.created_at ? dateFriendly(data.created_at, 'DD MMM YYYY, HH:mm:ss') : '-',
		resolvedAt: data.resolved_at ? dateFriendly(data.resolved_at, 'DD MMM YYYY, HH:mm:ss') : '-',
		resolvedBy: data.resolve_by_user || null,
	};
};

/**
 * transform error list
 * @param {Array} error
 * @returns {Array} error list
 */
export const transformErrorList = (data = []) => (
	data.map(transformErrorData)
);
